import { FC, forwardRef } from "react";
import {
  faBan,
  faCheck,
  faExclamationCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mantine/core";

import { AggregateIssueState } from "@protos/issues/v1/issues";

import styles from "./MinimalInilneTriagePopoverTarget.module.css";
export interface MinimalInlineTriagePopoverTargetProps {
  issueState: AggregateIssueState;
  isFixed: boolean;
  onClick: () => void;
  isLoading: boolean;
}

/**
 * The inline triage popover target with minimal styling - only used in individual finding cards.
 * @finding A formatted finding.
 * @onClick A function to set the state to determine when the popover dropdown will be displayed.
 * @isLoading If true, the component shows a loading state. If false, it shows the default state.
 *
 */
export const MinimalInlineTriagePopoverTarget: FC<MinimalInlineTriagePopoverTargetProps> =
  forwardRef<HTMLButtonElement, MinimalInlineTriagePopoverTargetProps>(
    ({ issueState, isFixed, onClick, isLoading }, ref) => {
      const icon = isFixed
        ? faCheck
        : issueState === AggregateIssueState.OPEN
        ? faExclamationCircle
        : faBan;

      return (
        <Button
          ref={ref}
          size="compact-sm"
          variant="outline"
          onClick={onClick}
          leftSection={<FontAwesomeIcon icon={icon} />}
          loading={isLoading}
          c={issueState === AggregateIssueState.OPEN ? "blue" : "violet"}
          disabled={isFixed}
          classNames={{
            section: styles.section,
            label: styles.label,
          }}
        >
          {isFixed
            ? "Fixed"
            : issueState === AggregateIssueState.OPEN
            ? "Open"
            : "Ignored"}
        </Button>
      );
    }
  );
